module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('select', {
    staticClass: "form-control",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "name": _vm.name,
      "id": _vm.name,
      "placeholder": _vm.placeholder,
      "disabled": _vm.disabled
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ../~/vue-loader/lib/template-compiler?{"id":"data-v-02049ea6"}!../~/vue-loader/lib/selector.js?type=template&index=0!./src/components/forms/Selectize.vue
// module id = 918
// module chunks = 0